import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { TrendingDown } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function EventsAddExpensePage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Lançar Custo no Evento"
      description="Registre custos e despesas dos seus eventos."
      icon={TrendingDown}
    />
  
    </MainLayout>);
}

